<template>

    <Toast/>

    <MenuFinancialCompact v-if="userStore.user?.roles?.includes('ROLE_ISORISE')" />
    <MenuHealthCompact v-else />

    <!-- TWO LOGOS -->
    <!-- FULL HEADER: desktop dropdowns visible (stacking fixed), mobile toggle works -->
    <!--    <div class="px-3 lg:px-6 surface-overlay relative">-->

    <!--        &lt;!&ndash; Top bar &ndash;&gt;-->
    <!--        <div class="py-3 lg:py-3 px-3 lg:px-6 relative"-->
    <!--             style="display:grid; grid-template-columns:auto 1fr auto; align-items:center; min-height:64px; z-index:1;">-->

    <!--            &lt;!&ndash; Left: first logo &ndash;&gt;-->
    <!--            <img-->
    <!--                src="images/logos/logo.sterlingpractice.rev1.png"-->
    <!--                alt="Sterling Practice"-->
    <!--                height="45"-->
    <!--                class="m-0"-->
    <!--            />-->

    <!--            &lt;!&ndash; Center: second logo (kept under the nav so it can't cover dropdowns) &ndash;&gt;-->
    <!--            <div class="flex justify-content-center pointer-events-none" style="z-index:1;">-->
    <!--                <img-->
    <!--                    src="images/blocks/logos/kitrin-logo-black-revised-software-rev2.png"-->
    <!--                    alt="Kitrin IsoEvolve"-->
    <!--                    height="45"-->
    <!--                    class="pointer-events-auto"-->
    <!--                />-->
    <!--            </div>-->

    <!--            &lt;!&ndash; Right: hamburger (mobile) &ndash;&gt;-->
    <!--            <div class="flex align-items-center justify-content-end">-->
    <!--                <a-->
    <!--                    v-ripple-->
    <!--                    class="cursor-pointer block lg:hidden text-700 p-ripple"-->
    <!--                    v-styleclass="{ selector: '#navbar-7', enterClass: 'hidden', leaveToClass: 'hidden', hideOnOutsideClick: true }"-->
    <!--                >-->
    <!--                    <i class="pi pi-bars text-4xl"></i>-->
    <!--                </a>-->
    <!--            </div>-->
    <!--        </div>-->

    <!--        &lt;!&ndash; NAV &ndash;&gt;-->
    <!--        <div-->
    <!--            id="navbar-7"-->
    <!--            class="align-items-center flex-grow-1 justify-content-between hidden lg:flex absolute lg:static w-full surface-overlay left-0 top-100 shadow-2 lg:shadow-none"-->
    <!--            style="z-index: 5;"-->
    <!--        >-->
    <!--            <ul class="list-none p-0 m-0 flex lg:align-items-center select-none flex-column lg:flex-row">-->

    <!--                &lt;!&ndash; Overview &ndash;&gt;-->
    <!--                <li class="lg:relative">-->
    <!--                    <a v-ripple-->
    <!--                       class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple"-->
    <!--                       v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                        <i class="pi pi-users mr-2"></i>-->
    <!--                        <span>Overview</span>-->
    <!--                        <i class="pi pi-angle-down ml-auto lg:ml-3"></i>-->
    <!--                    </a>-->

    <!--                    &lt;!&ndash; 1st level dropdown &ndash;&gt;-->
    <!--                    <ul class="list-none py-3 px-6 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer"-->
    <!--                        style="z-index: 6;">-->
    <!--                        <li>-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                <i class="pi pi-user-plus mr-2"></i>-->
    <!--                                <span class="font-medium">Dashboard</span>-->
    <!--                            </a>-->
    <!--                        </li>-->

    <!--                        &lt;!&ndash; Nested &ndash;&gt;-->
    <!--                        <li class="relative lg:relative">-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"-->
    <!--                               v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                                <i class="pi pi-search mr-2"></i>-->
    <!--                                <span class="font-medium">Audit Trail</span>-->
    <!--                                <i class="pi pi-angle-down ml-auto lg:-rotate-90"></i>-->
    <!--                            </a>-->

    <!--                            &lt;!&ndash; 2nd level dropdown &ndash;&gt;-->
    <!--                            <ul class="list-none py-3 pl-3 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer left-100 top-0"-->
    <!--                                style="z-index: 7;">-->
    <!--                                <li>-->
    <!--                                    <a @click="processAuditTrailOverview" v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">Overview</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                                <li>-->
    <!--                                    <a @click="processAuditTrailNew" v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">New Audit Trail</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                            </ul>-->
    <!--                        </li>-->

    <!--                        &lt;!&ndash; Another nested &ndash;&gt;-->
    <!--                        <li class="relative lg:relative">-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"-->
    <!--                               v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                                <i class="pi pi-search mr-2"></i>-->
    <!--                                <span class="font-medium">Search</span>-->
    <!--                                <i class="pi pi-angle-down ml-auto lg:-rotate-90"></i>-->
    <!--                            </a>-->
    <!--                            <ul class="list-none py-3 pl-3 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer left-100 top-0"-->
    <!--                                style="z-index: 7;">-->
    <!--                                <li>-->
    <!--                                    <a v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">Purchases</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                                <li class="relative">-->
    <!--                                    <a v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-comments mr-2"></i>-->
    <!--                                        <span class="font-medium">Messages</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                            </ul>-->
    <!--                        </li>-->
    <!--                    </ul>-->
    <!--                </li>-->

    <!--                &lt;!&ndash; Clients &ndash;&gt;-->
    <!--                <li class="lg:relative">-->
    <!--                    <a v-ripple-->
    <!--                       class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple"-->
    <!--                       v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                        <i class="pi pi-users mr-2"></i>-->
    <!--                        <span>Clients</span>-->
    <!--                        <i class="pi pi-angle-down ml-auto lg:ml-3"></i>-->
    <!--                    </a>-->

    <!--                    <ul class="list-none py-3 px-6 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer"-->
    <!--                        style="z-index: 6;">-->
    <!--                        <li>-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                <i class="pi pi-user-plus mr-2"></i>-->
    <!--                                <span class="font-medium">Dashboard</span>-->
    <!--                            </a>-->
    <!--                        </li>-->

    <!--                        <li class="relative">-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"-->
    <!--                               v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                                <i class="pi pi-search mr-2"></i>-->
    <!--                                <span class="font-medium">Audit Trail</span>-->
    <!--                                <i class="pi pi-angle-down ml-auto lg:-rotate-90"></i>-->
    <!--                            </a>-->
    <!--                            <ul class="list-none py-3 pl-3 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer left-100 top-0"-->
    <!--                                style="z-index: 7;">-->
    <!--                                <li>-->
    <!--                                    <a @click="processAuditTrailOverview" v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">Overview</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                                <li>-->
    <!--                                    <a @click="processAuditTrailNew" v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">New Audit Trail</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                            </ul>-->
    <!--                        </li>-->

    <!--                        <li class="relative">-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"-->
    <!--                               v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                                <i class="pi pi-search mr-2"></i>-->
    <!--                                <span class="font-medium">Search</span>-->
    <!--                                <i class="pi pi-angle-down ml-auto lg:-rotate-90"></i>-->
    <!--                            </a>-->
    <!--                            <ul class="list-none py-3 pl-3 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer left-100 top-0"-->
    <!--                                style="z-index: 7;">-->
    <!--                                <li>-->
    <!--                                    <a v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">Purchases</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                                <li class="relative">-->
    <!--                                    <a v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-comments mr-2"></i>-->
    <!--                                        <span class="font-medium">Messages</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                            </ul>-->
    <!--                        </li>-->
    <!--                    </ul>-->
    <!--                </li>-->

    <!--                &lt;!&ndash; Calendar (no dropdown) &ndash;&gt;-->
    <!--                <li>-->
    <!--                    <a v-ripple-->
    <!--                       class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
    <!--                        <i class="pi pi-calendar mr-2"></i>-->
    <!--                        <span>Calendar</span>-->
    <!--                    </a>-->
    <!--                </li>-->

    <!--                &lt;!&ndash; Financials &ndash;&gt;-->
    <!--                <li class="lg:relative">-->
    <!--                    <a v-ripple-->
    <!--                       class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple"-->
    <!--                       v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                        <i class="pi pi-users mr-2"></i>-->
    <!--                        <span>Financials</span>-->
    <!--                        <i class="pi pi-angle-down ml-auto lg:ml-3"></i>-->
    <!--                    </a>-->

    <!--                    <ul class="list-none py-3 px-6 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer"-->
    <!--                        style="z-index: 6;">-->
    <!--                        <li>-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                <i class="pi pi-user-plus mr-2"></i>-->
    <!--                                <span class="font-medium">Dashboard</span>-->
    <!--                            </a>-->
    <!--                        </li>-->

    <!--                        <li class="relative">-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"-->
    <!--                               v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                                <i class="pi pi-search mr-2"></i>-->
    <!--                                <span class="font-medium">Audit Trail</span>-->
    <!--                                <i class="pi pi-angle-down ml-auto lg:-rotate-90"></i>-->
    <!--                            </a>-->
    <!--                            <ul class="list-none py-3 pl-3 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer left-100 top-0"-->
    <!--                                style="z-index: 7;">-->
    <!--                                <li>-->
    <!--                                    <a @click="processAuditTrailOverview" v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">Overview</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                                <li>-->
    <!--                                    <a @click="processAuditTrailNew" v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">New Audit Trail</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                            </ul>-->
    <!--                        </li>-->

    <!--                        <li class="relative">-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"-->
    <!--                               v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                                <i class="pi pi-search mr-2"></i>-->
    <!--                                <span class="font-medium">Search</span>-->
    <!--                                <i class="pi pi-angle-down ml-auto lg:-rotate-90"></i>-->
    <!--                            </a>-->
    <!--                            <ul class="list-none py-3 pl-3 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer left-100 top-0"-->
    <!--                                style="z-index: 7;">-->
    <!--                                <li>-->
    <!--                                    <a v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">Purchases</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                                <li class="relative">-->
    <!--                                    <a v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-comments mr-2"></i>-->
    <!--                                        <span class="font-medium">Messages</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                            </ul>-->
    <!--                        </li>-->
    <!--                    </ul>-->
    <!--                </li>-->

    <!--                &lt;!&ndash; Account &ndash;&gt;-->
    <!--                <li class="lg:relative">-->
    <!--                    <a v-ripple-->
    <!--                       class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple"-->
    <!--                       v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                        <i class="pi pi-users mr-2"></i>-->
    <!--                        <span>Account</span>-->
    <!--                        <i class="pi pi-angle-down ml-auto lg:ml-3"></i>-->
    <!--                    </a>-->

    <!--                    <ul class="list-none py-3 px-6 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer"-->
    <!--                        style="z-index: 6;">-->
    <!--                        <li>-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                <i class="pi pi-user-plus mr-2"></i>-->
    <!--                                <span class="font-medium">Dashboard</span>-->
    <!--                            </a>-->
    <!--                        </li>-->

    <!--                        <li class="relative">-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"-->
    <!--                               v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                                <i class="pi pi-search mr-2"></i>-->
    <!--                                <span class="font-medium">Audit Trail</span>-->
    <!--                                <i class="pi pi-angle-down ml-auto lg:-rotate-90"></i>-->
    <!--                            </a>-->
    <!--                            <ul class="list-none py-3 pl-3 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer left-100 top-0"-->
    <!--                                style="z-index: 7;">-->
    <!--                                <li>-->
    <!--                                    <a @click="processAuditTrailOverview" v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">Overview</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                                <li>-->
    <!--                                    <a @click="processAuditTrailNew" v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">New Audit Trail</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                            </ul>-->
    <!--                        </li>-->

    <!--                        <li class="relative">-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"-->
    <!--                               v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                                <i class="pi pi-search mr-2"></i>-->
    <!--                                <span class="font-medium">Search</span>-->
    <!--                                <i class="pi pi-angle-down ml-auto lg:-rotate-90"></i>-->
    <!--                            </a>-->
    <!--                            <ul class="list-none py-3 pl-3 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer left-100 top-0"-->
    <!--                                style="z-index: 7;">-->
    <!--                                <li>-->
    <!--                                    <a v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">Purchases</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                                <li class="relative">-->
    <!--                                    <a v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-comments mr-2"></i>-->
    <!--                                        <span class="font-medium">Messages</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                            </ul>-->
    <!--                        </li>-->
    <!--                    </ul>-->
    <!--                </li>-->

    <!--                &lt;!&ndash; Configuration &ndash;&gt;-->
    <!--                <li class="lg:relative">-->
    <!--                    <a v-ripple-->
    <!--                       class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple"-->
    <!--                       v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                        <i class="pi pi-users mr-2"></i>-->
    <!--                        <span>Configuration</span>-->
    <!--                        <i class="pi pi-angle-down ml-auto lg:ml-3"></i>-->
    <!--                    </a>-->

    <!--                    <ul class="list-none py-3 px-6 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer"-->
    <!--                        style="z-index: 6;">-->
    <!--                        <li>-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                <i class="pi pi-user-plus mr-2"></i>-->
    <!--                                <span class="font-medium">Dashboard</span>-->
    <!--                            </a>-->
    <!--                        </li>-->

    <!--                        <li class="relative">-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"-->
    <!--                               v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                                <i class="pi pi-search mr-2"></i>-->
    <!--                                <span class="font-medium">Audit Trail</span>-->
    <!--                                <i class="pi pi-angle-down ml-auto lg:-rotate-90"></i>-->
    <!--                            </a>-->
    <!--                            <ul class="list-none py-3 pl-3 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer left-100 top-0"-->
    <!--                                style="z-index: 7;">-->
    <!--                                <li>-->
    <!--                                    <a @click="processAuditTrailOverview" v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">Overview</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                                <li>-->
    <!--                                    <a @click="processAuditTrailNew" v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">New Audit Trail</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                            </ul>-->
    <!--                        </li>-->

    <!--                        <li class="relative">-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"-->
    <!--                               v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                                <i class="pi pi-search mr-2"></i>-->
    <!--                                <span class="font-medium">Search</span>-->
    <!--                                <i class="pi pi-angle-down ml-auto lg:-rotate-90"></i>-->
    <!--                            </a>-->
    <!--                            <ul class="list-none py-3 pl-3 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer left-100 top-0"-->
    <!--                                style="z-index: 7;">-->
    <!--                                <li>-->
    <!--                                    <a v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">Purchases</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                                <li class="relative">-->
    <!--                                    <a v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-comments mr-2"></i>-->
    <!--                                        <span class="font-medium">Messages</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                            </ul>-->
    <!--                        </li>-->
    <!--                    </ul>-->
    <!--                </li>-->

    <!--                &lt;!&ndash; Applications (no dropdown) &ndash;&gt;-->
    <!--                <li>-->
    <!--                    <a v-ripple-->
    <!--                       class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
    <!--                        <i class="pi pi-chart-line mr-2"></i>-->
    <!--                        <span>Applications</span>-->
    <!--                    </a>-->
    <!--                </li>-->

    <!--            </ul>-->

    <!--            &lt;!&ndash; Right side icons/actions &ndash;&gt;-->
    <!--            <ul class="list-none p-0 m-0 flex lg:align-items-center select-none flex-column lg:flex-row border-top-1 surface-border lg:border-top-none">-->
    <!--                <li>-->
    <!--                    <a v-ripple-->
    <!--                       class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
    <!--                        <i class="pi pi-bell text-base lg:text-2xl mr-2 lg:mr-0" v-badge.danger></i>-->
    <!--                        <span class="block lg:hidden font-medium">Notifications</span>-->
    <!--                    </a>-->
    <!--                </li>-->
    <!--                <li>-->
    <!--                    <a v-ripple-->
    <!--                       class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
    <!--                        <i class="pi pi-power-off text-base lg:text-2xl mr-2 lg:mr-0"></i>-->
    <!--                        <span class="block lg:hidden font-medium">Logout</span>-->
    <!--                    </a>-->
    <!--                </li>-->
    <!--            </ul>-->
    <!--        </div>-->
    <!--    </div>-->


    <div class="px-6 surface-overlay relative">

        <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
            <li class="pr-3"><a class="cursor-pointer">Operational Clarity</a></li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Products</a></li>
        </ul>

        <div v-show="activeTab === 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Products</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callNewProduct" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>New Product</span>
                                </a>
                            </li>
                            <li v-if="companyConfiguration.type === 'F'">
                                <a @click="callImportProducts" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Import Product Information</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <DataTable
                        :value="products"
                        :paginator="true"
                        class="p-datatable-gridlines"
                        :rows="100"
                        dataKey="id"
                        :rowsPerPageOptions="[10,20,50,100]"
                        :rowHover="true"
                        :striped-rows="true"
                        :reorderableColumns="true"
                        :sortMode="'multiple'"
                        v-model:filters="filters"
                        filterDisplay="menu"
                        :loading="loading"
                        responsiveLayout="scroll"
                        :globalFilterFields="['name', 'uniqueId', 'supplierName', 'billingPlanName']">

                        <template #header>
                            <div class="p-grid">
                                <div class="grid">
                                    <div class="col-12 lg:col-6 p-2">
                                        <MultiSelect :modelValue="selectedColumns" :options="columnsFullList"
                                                     optionLabel="header"
                                                     @update:modelValue="onToggleColumns"
                                                     display="chip" placeholder="Select Columns"/>
                                    </div>
                                    <div class="col-12 lg:col-6 p-2">
                                        <MultiSelect :modelValue="selectedStandardFilter" :options="standardFilters"
                                                     optionLabel="header"
                                                     @update:modelValue="onToggleStandardFilters"
                                                     display="chip" placeholder="Select Standard Filter"/>
                                    </div>
                                </div>

                                <div class="grid">
                                    <div class="col-12 lg:col-6 p-2">
                                        <Button type="button" icon="pi pi-filter-slash" label="Clear Search"
                                                class="p-button-outlined p-ml-2" @click="clearFilter()"/>
                                    </div>
                                    <div class="col-12 lg:col-6 p-2">
                                        <Button type="button" icon="pi pi-replay" label="Restore to Original View"
                                                class="p-button-outlined" @click="restoreToOriginal()"/>
                                    </div>
                                </div>

                                <div class="p-col-12 p-md-2">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"/>
                                        <InputText v-model="filters['global'].value"
                                                   placeholder="Keyword Search on Name, Unique ID, Supplier Name or Billing Plan Name"
                                                   style="width: 100%"/>
                                    </span>
                                </div>
                            </div>

                        </template>

                        <template #empty>
                            No products found.
                        </template>

                        <template #loading>
                            Loading products. Please wait.
                        </template>

                        <Column field="selectAnOption" style="width: 10%">
                            <template #body="{ data }">
                                <SplitButton icon="pi pi-pencil" label="Select" :model="getFilteredItems(data)"
                                             severity="success"
                                             @click="chooseBlankSelection(data)" class="mb-2 mr-2 ml-2 mt-2"/>
                            </template>
                        </Column>

                        <Column field="uniqueId" header="Unique ID" :sortable="true"/>
                        <Column field="name" header="Name" :sortable="true"/>

                        <Column field="status" header="Status" :sortable="true">
                            <template #body="{data}">
                                <span class="p-column-title">Status</span>
                                <span v-if="data.status === 'I'"
                                      :class="'status-badge status-' + data.status">Inactive</span>
                                <span v-if="data.status === 'A'"
                                      :class="'status-badge status-' + data.status">Active</span>
                            </template>
                        </Column>

                        <Column v-for="col in selectedColumns"
                                :key="col.field"
                                :field="col.field"
                                :header="col.header"
                                :sortable="col.sortable"/>

                    </DataTable>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 2" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Update Product {{ this.product.name }}</h3>

                    <div class="field">
                        <label for="name">Name</label>
                        <InputText id="name" v-model.trim="product.name" required="true"/>
                    </div>

                    <div class="field">
                        <label for="supplier">Supplier</label>
                        <AutoComplete placeholder="Search or Select" :dropdown="true" :multiple="false"
                                      v-model="product.supplierName" :suggestions="filteredSuppliers"
                                      @complete="searchSuppliers($event)" field="name"/>
                    </div>

                    <div class="field">
                        <label for="billingPlan">Billing Plan</label>
                        <AutoComplete placeholder="Search or Select" :dropdown="true" :multiple="false"
                                      v-model="product.billingPlanName" :suggestions="filteredBillingPlans"
                                      @complete="searchBillingPlans($event)" field="name"/>
                    </div>

                    <div class="field">
                        <label for="description">Description</label>
                        <Textarea v-model="product.description" :autoResize="true" rows="10" cols="50"/>
                    </div>

                    <div class="field">
                        <label for="uniqueId">Unique #</label>
                        <InputText id="uniqueId" v-model.trim="product.uniqueId" required="true"/>
                    </div>

                    <div class="field">
                        <label for="premium">Premium</label>
                        <InputText id="premium" v-model.trim="product.premium" required="true"/>
                    </div>

                    <div class="field">
                        <label for="value">Value</label>
                        <InputText id="value" v-model.trim="product.value" required="true"/>
                    </div>

                    <div v-if="companyConfiguration.type === 'F'" class="field">
                        <label for="Label">Label</label>
                        <Dropdown v-model="product.label" :options="statusTypes" optionLabel="name" optionValue="code"
                                  placeholder="Select a Label"/>
                    </div>

                    <div class="field">
                        <label for="status">Status</label>
                        <Dropdown v-model="product.status" :options="statusTypes" optionLabel="name" optionValue="code"
                                  placeholder="Select an Action"/>
                    </div>

                    <Button label="Update" class="mr-2 mb-2" @click="updateProduct"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 3" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Delete Product {{ this.product.name }}</h3>

                    <div class="field">
                        <label for="deleteConfirmationResponse">Do You Wish to Delete this Product?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <Button label="Delete" class="mr-2 mb-2" @click="deleteProduct"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callReset"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 4" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>New Product</h3>

                    <div class="field">
                        <label for="name">Name</label>
                        <InputText id="name" v-model.trim="newProduct.name" required="true"/>
                    </div>

                    <div class="field">
                        <label for="supplier">Supplier</label>
                        <AutoComplete placeholder="Search or Select" :dropdown="true" :multiple="false"
                                      v-model="newProduct.supplier" :suggestions="filteredSuppliers"
                                      @complete="searchSuppliers($event)" field="name"/>
                    </div>

                    <div class="field">
                        <label for="billingPlan">Billing Plan</label>
                        <AutoComplete placeholder="Search or Select" :dropdown="true" :multiple="false"
                                      v-model="newProduct.billingPlan" :suggestions="filteredBillingPlans"
                                      @complete="searchBillingPlans($event)" field="name"/>
                    </div>

                    <div class="field">
                        <label for="description">Description</label>
                        <Textarea v-model="newProduct.description" :autoResize="true" rows="10" cols="50"/>
                    </div>

                    <div class="field">
                        <label for="uniqueId">Unique #</label>
                        <InputText id="uniqueId" v-model.trim="newProduct.uniqueId" required="true"/>
                    </div>

                    <div class="field">
                        <label for="premium">Premium</label>
                        <InputText id="premium" v-model.trim="newProduct.premium" required="true"/>
                    </div>

                    <div class="field">
                        <label for="value">Value</label>
                        <InputText id="value" v-model.trim="newProduct.value" required="true"/>
                    </div>

                    <div v-if="companyConfiguration.type === 'F'" class="field">
                        <label for="Label">Label</label>
                        <Dropdown v-model="newProduct.label" :options="statusTypes" optionLabel="name" optionValue="code"
                                  placeholder="Select a Label"/>
                    </div>

                    <Button label="Create" class="mr-2 mb-2" @click="createProduct"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callReset"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 5" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>View Clients for Product {{ this.product.name }}</h3>

                    <DataTable
                        :value="clientProducts"
                        :paginator="true"
                        class="p-datatable-gridlines"
                        :rows="100"
                        dataKey="id"
                        :rowsPerPageOptions="[10,20,50,100]"
                        :rowHover="true"
                        :striped-rows="true"
                        :reorderableColumns="true"
                        :sortMode="'multiple'"
                        v-model:filters="filters"
                        filterDisplay="menu"
                        :loading="loading"
                        responsiveLayout="scroll"
                        :globalFilterFields="['name', 'uniqueId', 'supplierName', 'billingPlanName']">

                        <template #header>
                            <div class="p-grid">
                                <div class="grid">
                                    <div class="col-12 lg:col-6 p-2">
                                        <MultiSelect :modelValue="selectedColumns" :options="columnsFullList"
                                                     optionLabel="header"
                                                     @update:modelValue="onToggleColumns"
                                                     display="chip" placeholder="Select Columns"/>
                                    </div>
                                    <div class="col-12 lg:col-6 p-2">
                                        <MultiSelect :modelValue="selectedStandardFilter" :options="standardFilters"
                                                     optionLabel="header"
                                                     @update:modelValue="onToggleStandardFilters"
                                                     display="chip" placeholder="Select Standard Filter"/>
                                    </div>
                                </div>

                                <div class="grid">
                                    <div class="col-12 lg:col-6 p-2">
                                        <Button type="button" icon="pi pi-filter-slash" label="Clear Search"
                                                class="p-button-outlined p-ml-2" @click="clearFilter()"/>
                                    </div>
                                    <div class="col-12 lg:col-6 p-2">
                                        <Button type="button" icon="pi pi-replay" label="Restore to Original View"
                                                class="p-button-outlined" @click="restoreToOriginal()"/>
                                    </div>
                                </div>

                                <div class="p-col-12 p-md-2">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"/>
                                        <InputText v-model="filters['global'].value"
                                                   placeholder="Keyword Search on Name, Unique ID, Supplier Name or Billing Plan Name"
                                                   style="width: 100%"/>
                                    </span>
                                </div>
                            </div>

                        </template>

                        <template #empty>
                            No clients found for product.
                        </template>

                        <template #loading>
                            Loading clients for product. Please wait.
                        </template>

                        <Column field="clientName" header="Client Name" :sortable="true"/>
                        <Column field="uniqueId" header="Unique ID" :sortable="true"/>
                        <Column field="name" header="Name" :sortable="true"/>

                        <Column field="status" header="Status" :sortable="true">
                            <template #body="{data}">
                                <span class="p-column-title">Status</span>
                                <span v-if="data.status === 'I'"
                                      :class="'status-badge status-' + data.status">Inactive</span>
                                <span v-if="data.status === 'A'"
                                      :class="'status-badge status-' + data.status">Active</span>
                            </template>
                        </Column>

                        <Column v-for="col in selectedColumns"
                                :key="col.field"
                                :field="col.field"
                                :header="col.header"
                                :sortable="col.sortable"/>

                    </DataTable>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 6" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Import Product Information</h3>

                    <div class="field">
                        <label for="inputFormat">Input Format</label>
                        <Dropdown v-model="inputFormat" :options="inputFormats" optionLabel="name" optionValue="code"
                                  placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="inputPassword">Password (if applicable)</label>
                        <InputText id="inputPassword" v-model.trim="inputPassword" required="true"/>
                    </div>

                    <div class="p-field">
                        <input
                            type="file"
                            ref="fileInput"
                            @change="handleFileUpload"
                            accept=".csv, application/pdf"/>
                    </div>

                    <br/>

                    <div class="p-field">
                        <Button label="Review" :loading="submitted" class="mr-2 mb-2" :disabled="!file"
                                @click="submitFile"></Button>
                    </div>

                    <br/>
                    <div class="p-field">
                        <Button label="Cancel" class="mr-2 mb-2" :loading="submitted"
                                @click="callResetImportPayments"></Button>
                    </div>

                </div>
            </div>
        </div>

    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import {FilterMatchMode, FilterOperator} from "primevue/api";
import CompanyService from "@/service/CompanyService";
import ProductService from "@/service/ProductService";
import ClientProductService from "@/service/ClientProductService";
import SupplierService from "@/service/SupplierService";
import BillingPlanService from "@/service/BillingPlanService";
import MenuFinancialCompact from "@/components/menu/famodule/MenuFinancialCompact.vue";

export default {
    components: {
        MenuFinancialCompact,
        MenuHealthCompact,
        IsoEvolveFooter
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    created() {
        this.initFilters();

        this.columnsDefault = [
            {field: 'premium', header: 'Premium', sortable: true},
            {field: 'value', header: 'Value', sortable: true}
        ];

        this.columnsFullList = [
            {field: 'premium', header: 'Premium', sortable: true},
            {field: 'value', header: 'Value', sortable: true},
            {field: 'supplierName', header: 'Supplier Name', sortable: true},
            {field: 'billingPlanName', header: 'Billing Plan Name', sortable: true}
        ];

        this.selectedColumns = this.columnsDefault;

        this.standardFilters = [
            {field: 'today', header: 'Today'},
            {field: 'thisMonth', header: 'This Month'}
        ];

    },
    async mounted() {
        try {
            const userPingResponse = await UserService.getUserPing();
            console.log("[PmOverviewDashboard][mounted] System is active.");
            console.log("[PmOverviewDashboard][mounted] Data = ", userPingResponse);
        } catch (e) {
            console.log("[PmOverviewDashboard][mounted] System is NOT active.");
            console.log("[PmOverviewDashboard][mounted] Error = ", e);
            this.userStore.clearUser();
            this.$router.push("login");
            return;
        }

        if (!this.userStore.user.id) {
            console.log("[PmOverviewDashboard][mounted] User is NOT defined.");
            this.userStore.clearUser();
            this.$router.push('login');
            return;
        }

        await this.loadCompanyContext();
    },
    data() {

        return {
            profile: {},
            activeTab: 1,
            companyConfiguration: {},
            userConfiguration: {},
            filters: null,
            loading: true,
            submitted: false,
            filteredSuppliers: [],
            filteredBillingPlans: [],
            filteredItemsCache: new Map(),
            product: {},
            newProduct: {},
            products: null,
            originalProducts: null,
            clientProducts: null,
            confirmationResponse: 'N',
            selectedColumns: null,
            columnsDefault: null,
            columnsFullList: null,
            selectedStandardFilter: null,
            standardFilters: null,
            confirmationTypes: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
            statusTypes: [
                {name: 'Active', code: 'A'},
                {name: 'Inactive', code: 'I'}
            ],
            inputFormat: null,
            file: null,
            url: "/product/import/discovery/1",
            fileAccept: '.csv, application/pdf',
            inputFormats: [
                {name: 'Generic Format (CSV)', code: '001'},
                {name: 'Discovery Life (CSV)', code: '002'},
                {name: 'Sanlam Glacier (CSV)', code: '003'},
                {name: 'Turnberry (CSV)', code: '004'},
            ],
        }
    },
    watch: {
        products() {
            this.filteredItemsCache.clear();
        },
        'userStore.activeCompanyId': {
            immediate: false,
            async handler(newCompanyId, oldCompanyId) {
                if (!newCompanyId || newCompanyId === oldCompanyId) {
                    return;
                }

                console.log(
                    '[Appointments][watch] Company changed:',
                    oldCompanyId,
                    '→',
                    newCompanyId
                );

                await this.loadCompanyContext();
            }
        }
    },
    methods: {
        async loadCompanyContext() {
            try {
                try {
                    // Attempt to get user data
                    const userData = await UserService.getUser(this.userStore.user.id);
                    this.profile = userData.data;
                } catch (e) {
                    console.error("[AppointmentsNew][mounted] Error fetching user data = ", e);
                    this.userStore.clearUser();
                    this.$router.push('login');
                    return;
                }

                this.profile.companyId = this.userStore.activeCompanyId;

                const [userConfigurationData, companyConfigurationData, productsData] = await Promise.all([
                    UserService.getUserConfig(this.userStore.user.id),
                    CompanyService.getCompanyConfiguration(this.profile.companyId),
                    ProductService.getCompanyProducts(this.profile.companyId)
                ]);

                this.userConfiguration = userConfigurationData.data;
                this.companyConfiguration = companyConfigurationData.data;

                this.products = productsData.data;
                this.originalProducts = [...this.products];

                this.loading = false;

            } catch (e) {
                console.error("[PhoneCalls][mounted] Error fetching additional data = ", e);
            }

            console.log("[PhoneCalls][mounted] this.products = ", this.products);
            console.log("[PhoneCalls][mounted] this.userConfiguration = ", this.userConfiguration);
            console.log("[PhoneCalls][mounted] this.companyConfiguration = ", this.companyConfiguration);
        },
        initFilters() {
            this.filters = {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'name': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'uniqueId': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'supplierName': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'billingPlanName': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                }
            }
        },
        clearFilter() {
            this.initFilters();
        },
        restoreToOriginal() {
            window.location.reload();
        },
        callReset() {
            this.activeTab = 1;
        },
        callNewProduct() {
            this.newProduct = {
                premium: 0,
                value: 0
            };

            this.activeTab = 4;
        },
        callImportProducts() {
            this.activeTab = 6;
            this.inputFormat = '001';
        },
        callHelp() {
            console.log('[ConfigurationBilling][callHelp] Start.');
        },
        callSupport() {
            console.log('[ConfigurationBilling][callSupport] Start.');
        },
        callUpdateProduct(data) {
            this.activeTab = 2;
            this.product = data;
        },
        callDeleteProduct(data) {
            this.activeTab = 3;
            this.confirmationResponse = 'N';
            this.product = data;
        },
        async callViewClientsForProduct(data) {
            this.activeTab = 5;
            this.product = data;

            const [clientProductData] = await Promise.all([
                ClientProductService.getClientsForProduct(this.product.id)
            ]);

            this.clientProducts = clientProductData.data;

        },
        onToggleColumns(value) {
            this.selectedColumns = this.columnsFullList.filter(col => value.includes(col));
        },
        onToggleStandardFilters(value) {

            if (value.length > 1) {
                // Keep the last selected option
                this.selectedStandardFilter = [value[value.length - 1]];
            } else {
                this.selectedStandardFilter = value;
            }

            const isTodaySelected = value.some(item => item.field === "today");
            const isThisMonthSelected = value.some(item => item.field === "thisMonth");

            if (this.products !== null) {

                if (isTodaySelected) {
                    // The filter "today" is present in selectedStandardFilters
                    console.log("[PhoneCalls] The filter 'today' is selected.");

                    const today = new Date();
                    const year = today.getFullYear();
                    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based in JS
                    const day = String(today.getDate()).padStart(2, '0');
                    const todayStr = `${year}-${month}-${day}`;

                    this.products = this.originalProducts.filter(product => {
                        // Assuming 'created' is in 'YYYY-MM-DD' format
                        return product.created.startsWith(todayStr);
                    });

                } else if (isThisMonthSelected) {
                    console.log("[PhoneCalls] The filter 'thisMonth' is selected.");

                    const today = new Date();
                    const year = today.getFullYear();
                    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based in JS
                    const monthStr = `${year}-${month}`;

                    this.products = this.originalProducts.filter(product => {
                        // Assuming 'created' is in 'YYYY-MM-DD' format
                        return product.created.startsWith(monthStr);
                    });

                } else {
                    // The filter "today" is not present in selectedStandardFilters
                    console.log("[PhoneCalls] No filters were selected.");
                    this.products = this.originalProducts;
                }

            } else {
                // Handle the case when auditTrails is null
                this.products = null;
            }
        },
        getFilteredItems(data) {
            if (this.filteredItemsCache.has(data.id)) {
                return this.filteredItemsCache.get(data.id);
            }

            const items = [];

            items.push({
                label: 'Update',
                class: 'mb-4 mr-4 ml-4 mt-4',
                command: () => {
                    console.log('Update action');
                    this.callUpdateProduct(data);
                }
            });

            items.push({
                label: 'Delete',
                class: 'mb-4 mr-4 ml-4 mt-4',
                command: () => {
                    console.log('Delete action');
                    this.callDeleteProduct(data);
                }
            });

            items.push({
                label: 'View Clients',
                class: 'mb-4 mr-4 ml-4 mt-4',
                command: () => {
                    console.log('View Clients action');
                    this.callViewClientsForProduct(data);
                }
            });

            console.log('[PhoneCalls][getFilteredItems] items = ', items);

            this.filteredItemsCache.set(data.id, items);

            return items;
        },
        chooseBlankSelection(data) {
            console.log('[PhoneCalls][chooseBlankSelection] data = ', data);
            this.$toast.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Please select a valid option.',
                life: 3000
            });
        },
        async updateProduct() {
            console.log("[PhoneCalls][updatePhoneCall] Start.");

            this.submitted = true;

            if (this.product.name.trim()) {

                try {

                    var tempBillingPlan = "";

                    try {
                        tempBillingPlan = this.product.billingPlanName.id;
                    } catch (error) {
                        tempBillingPlan = "";
                    }

                    var tempSupplier = "";

                    try {
                        tempSupplier = this.product.supplierName.id;
                    } catch (error) {
                        tempSupplier = "";
                    }

                    var productDto = {
                        name: this.product.name,
                        description: this.product.description,
                        uniqueId: this.product.uniqueId,
                        premium: this.product.premium,
                        value: this.product.value,
                        billingPlanId: tempBillingPlan,
                        supplierId: tempSupplier,
                        status: this.product.status
                    };

                    const response = await ProductService.updateProduct(this.product.id, productDto);
                    console.log('[PhoneCalls][updatePhoneCall] Response = ', response);

                    const [productData] = await Promise.all([
                        ProductService.getCompanyProducts(this.profile.companyId)
                    ]);

                    this.products = productData.data;
                    this.originalProducts = productData.data;
                    this.userStore.setProducts(productData.data);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Updated product',
                        life: 3000
                    });
                } catch (error) {
                    console.error('[PhoneCalls][updatePhoneCall] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to update product. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 1;
            this.product = {};
            this.submitted = false;

        },
        async deleteProduct() {
            this.submitted = true;

            if (this.confirmationResponse.trim() === "Y") {

                if (this.product.id) {

                    try {
                        // Delete the appointment
                        const response = await ProductService.deleteProduct(this.product.id);
                        console.log('[PhoneCalls][deletePhoneCall] Response = ', response);

                        const [productData] = await Promise.all([
                            ProductService.getCompanyProducts(this.profile.companyId)
                        ]);

                        this.products = productData.data;
                        this.originalProducts = productData.data;
                        this.userStore.setProducts(productData.data);

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Deleted product',
                            life: 3000
                        });

                    } catch (error) {
                        console.error('[PhoneCalls][deletePhoneCall] Error:', error);

                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to delete product. Please try again.',
                            life: 3000
                        });
                    }
                }

            }

            this.activeTab = 1;
            this.submitted = false;
        },
        async createProduct() {
            console.log("[PhoneCalls][createProduct] Start.");

            this.submitted = true;

            if (this.newProduct.name.trim()) {

                try {

                    var tempBillingPlan = "";

                    try {
                        tempBillingPlan = this.newProduct.billingPlan.id;
                    } catch (error) {
                        tempBillingPlan = "";
                    }

                    var tempSupplier = "";

                    try {
                        tempSupplier = this.newProduct.supplier.id;
                    } catch (error) {
                        tempSupplier = "";
                    }

                    console.log("[PhoneCallsNew][savePhoneCall] this.newProduct = ", this.newProduct);

                    var productDto = {
                        name: this.newProduct.name,
                        description: this.newProduct.description,
                        uniqueId: this.newProduct.uniqueId,
                        premium: this.newProduct.premium,
                        value: this.newProduct.value,
                        billingPlanId: tempBillingPlan,
                        supplierId: tempSupplier
                    };

                    console.log("[PhoneCallsNew][savePhoneCall] productDto = ", productDto);

                    const response = await ProductService.createProduct(this.profile.companyId, productDto);
                    console.log('[PhoneCalls][updatePhoneCall] Response = ', response);

                    const [productData] = await Promise.all([
                        ProductService.getCompanyProducts(this.profile.companyId)
                    ]);

                    this.products = productData.data;
                    this.originalProducts = productData.data;
                    this.userStore.setProducts(productData.data);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Created product',
                        life: 3000
                    });
                } catch (error) {
                    console.error('[PhoneCalls][updatePhoneCall] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to create product. Please try again.',
                        life: 3000
                    });
                }
            }

            this.activeTab = 1;
            this.product = {};
            this.submitted = false;

        },
        async searchSuppliers(event) {
            console.log("[" + name + "][searchSuppliers] event.query = ", event.query);

            try {
                const [supplierData] = await Promise.all([
                    SupplierService.getCompanySuppliers(this.profile.companyId)
                ]);

                this.filteredSuppliers = supplierData.data;
                console.log("[PhoneCallsNew][mounted] supplierData.data = ", supplierData.data);
            } catch (e) {
                console.error("[PhoneCallsNew][mounted] Could not find user config for user = ", this.userStore.user.id);
            }
        },
        async searchBillingPlans(event) {
            console.log("[" + name + "][searchBillingPlans] event.query = ", event.query);

            try {
                const [billingPlanData] = await Promise.all([
                    BillingPlanService.getBillingPlans(this.profile.companyId, event.query.toLowerCase())
                ]);

                this.filteredBillingPlans = billingPlanData.data;
                console.log("[PhoneCallsNew][mounted] billingPlanData.data = ", billingPlanData.data);
            } catch (e) {
                console.error("[PhoneCallsNew][mounted] Could not find user config for user = ", this.userStore.user.id);
            }

        }
    },
};
</script>

<style scoped lang="scss">
a {
    text-decoration: none;
}

::v-deep(.p-datatable-frozen-tbody) {
    font-weight: bold;
}

::v-deep(.p-datatable-scrollable .p-frozen-column) {
    font-weight: bold;
}

::v-deep(.p-progressbar) {
    height: .5rem;
    background-color: #D8DADC;

    .p-progressbar-value {
        background-color: #607D8B;
    }
}

.status-badge, .type-badge {
    border-radius: var(--border-radius);
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}

.status-badge {
    &.status-A {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-I {
        background: #B3E5FC;
        color: #23547B;
    }
}


.tabview-custom {
    i, span {
        vertical-align: middle;
    }

    span {
        margin: 0 .5rem;
    }
}

.p-tabview p {
    line-height: 1.5;
    margin: 0;
}

.accordion-custom {
    i, span {
        vertical-align: middle;
    }

    span {
        margin: 0 .5rem;
    }
}

.p-accordion p {
    line-height: 1.5;
    margin: 0;
}

.mb-2 {
    margin-bottom: 1rem;
}

.mr-2 {
    margin-right: 1rem;
}

</style>
